import { GetServerSideProps } from 'next'
import { getStocksListingServerSideProps } from '@/root/server/get-server-side-props/stocks/category'
import StocksCategory from '@/components/Stocks/Pages/CategoryPage/StocksCategory'

const Listing = props => {
  return <StocksCategory {...props} key={props.category} />
}
export default Listing

export const getServerSideProps: GetServerSideProps = async context => {
  const data = await getStocksListingServerSideProps(context)
  return data
}
